import React from 'react';
import { BoxArrowUpRight } from 'react-bootstrap-icons';

export const iconLink = <BoxArrowUpRight />;

export const FOOTER_NAVLINKS = [
	{
		label: 'cookies',
		href: 'https://www.smurfitwestrock.com/cookie-notice',
		icon: iconLink,
	},
	{
		label: 'cookie_settings',
		icon: iconLink,
		className: 'ot-sdk-show-settings',
	},
	{
		label: 'privacy_policy',
		href: 'https://www.smurfitwestrock.com/privacy-notice',
		icon: iconLink,
	},
	{
		label: 'legal',
		href: 'https://www.smurfitwestrock.com/legal-notice',
		icon: iconLink,
	},
	{
		label: 'accessibility',
		href: 'https://www.smurfitwestrock.com/accessibility-statement',
		icon: iconLink,
	},
];
